import { render } from "./candidates-modal.vue?vue&type=template&id=452fdf36"
import script from "./candidates-modal.vue?vue&type=script&lang=js"
export * from "./candidates-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__